import type { ThemeV2 } from './types/themeTypes';

export const DEFAULT_LIGHT_THEME: DefaultTheme = 'Macro Light';
export const DEFAULT_DARK_THEME: DefaultTheme = 'Macro Dark';

export const DEFAULT_THEMES = [
  {
    id: "Void",
    name: "Void",
    version: 2,
    depth: 0.249,
    tokens: {
      a0 :{ l :0.87, c: 0, h:   0 },
      a1 :{ l :0.87, c: 0, h:  40 },
      a2 :{ l :0.87, c: 0, h:  80 },
      a3 :{ l :0.87, c: 0, h: 120 },
      a4 :{ l :0.87, c: 0, h: 160 },
      b0 :{ l :0.12, c: 0, h:   0 },
      b1 :{ l :0.16, c: 0, h:   0 },
      b2 :{ l :0.23, c: 0, h:   0 },
      b3 :{ l :0.25, c: 0, h:   0 },
      b4 :{ l :0.30, c: 0, h:   0 },
      c0 :{ l :0.88, c: 0, h:   0 },
      c1 :{ l :0.84, c: 0, h:   0 },
      c2 :{ l :0.79, c: 0, h:   0 },
      c3 :{ l :0.73, c: 0, h:   0 },
      c4 :{ l :0.67, c: 0, h:   0 }
    }
  },
  {
    id: 'Sleepless',
    name: 'Sleepless',
    version: 2,
    depth: 0.1,
    tokens: {
      a0: { l: 0.71, c: 0.34, h:  21 },
      a1: { l: 0.71, c: 0.34, h:  61 },
      a2: { l: 0.71, c: 0.34, h: 101 },
      a3: { l: 0.71, c: 0.34, h: 141 },
      a4: { l: 0.71, c: 0.34, h: 181 },
      b0: { l: 0.14, c: 0.00, h:  21 },
      b1: { l: 0.16, c: 0.00, h:  21 },
      b2: { l: 0.18, c: 0.00, h:  21 },
      b3: { l: 0.20, c: 0.00, h:  21 },
      b4: { l: 0.23, c: 0.00, h:  21 },
      c0: { l: 0.95, c: 0.00, h:  21 },
      c1: { l: 0.83, c: 0.00, h:  21 },
      c2: { l: 0.75, c: 0.00, h:  21 },
      c3: { l: 0.63, c: 0.00, h:  21 },
      c4: { l: 0.55, c: 0.00, h:  21 },
    },
  },
  {
    id: 'Groove',
    name: 'Groove',
    version: 2,
    depth: 0.08,
    tokens: {
      a0: { l: 0.85, c: 0.34, h:  46 },
      a1: { l: 0.85, c: 0.34, h:  86 },
      a2: { l: 0.85, c: 0.34, h: 126 },
      a3: { l: 0.85, c: 0.34, h: 166 },
      a4: { l: 0.85, c: 0.34, h: 206 },
      b0: { l: 0.20, c: 0.00, h:  46 },
      b1: { l: 0.23, c: 0.00, h:  46 },
      b2: { l: 0.29, c: 0.00, h:  46 },
      b3: { l: 0.32, c: 0.00, h:  46 },
      b4: { l: 0.34, c: 0.00, h:  46 },
      c0: { l: 0.80, c: 0.00, h:  46 },
      c1: { l: 0.72, c: 0.00, h:  46 },
      c2: { l: 0.64, c: 0.00, h:  46 },
      c3: { l: 0.55, c: 0.00, h:  46 },
      c4: { l: 0.52, c: 0.00, h:  46 },
    },
  },
  {
    id: 'Macro Light',
    name: 'Macro Light',
    version: 2,
    depth: 0.09,
    tokens: {
      a0: { l: 0.65, c: 0.20, h:  59 },
      a1: { l: 0.65, c: 0.20, h:  99 },
      a2: { l: 0.65, c: 0.20, h: 139 },
      a3: { l: 0.65, c: 0.20, h: 179 },
      a4: { l: 0.65, c: 0.20, h: 219 },
      b0: { l: 0.96, c: 0.00, h:  59 },
      b1: { l: 0.92, c: 0.00, h:  59 },
      b2: { l: 0.91, c: 0.00, h:  59 },
      b3: { l: 0.92, c: 0.00, h:  59 },
      b4: { l: 0.91, c: 0.00, h:  59 },
      c0: { l: 0.14, c: 0.00, h:  59 },
      c1: { l: 0.40, c: 0.00, h:  59 },
      c2: { l: 0.55, c: 0.00, h:  59 },
      c3: { l: 0.65, c: 0.00, h:  59 },
      c4: { l: 0.75, c: 0.00, h:  59 },
    },
  },
  {
    id: 'Macro Dark',
    name: 'Macro Dark',
    version: 2,
    depth: 0.15,
    tokens: {
      a0: { l: 0.75, c: 0.20, h:  59 },
      a1: { l: 0.75, c: 0.20, h:  99 },
      a2: { l: 0.75, c: 0.20, h: 139 },
      a3: { l: 0.75, c: 0.20, h: 179 },
      a4: { l: 0.75, c: 0.20, h: 219 },
      b0: { l: 0.14, c: 0.00, h:  59 },
      b1: { l: 0.20, c: 0.00, h:  59 },
      b2: { l: 0.23, c: 0.00, h:  59 },
      b3: { l: 0.25, c: 0.00, h:  59 },
      b4: { l: 0.28, c: 0.00, h:  59 },
      c0: { l: 0.95, c: 0.00, h:  59 },
      c1: { l: 0.83, c: 0.00, h:  59 },
      c2: { l: 0.75, c: 0.00, h:  59 },
      c3: { l: 0.63, c: 0.00, h:  59 },
      c4: { l: 0.55, c: 0.00, h:  59 },
    },
  },
  {
    id: 'Satsuma',
    name: 'Satsuma',
    version: 2,
    depth: 0.06,
    tokens: {
      a0: { l: 0.67, c: 0.29, h:  82.13 },
      a1: { l: 0.67, c: 0.29, h: 122.13 },
      a2: { l: 0.67, c: 0.29, h: 162.13 },
      a3: { l: 0.67, c: 0.29, h: 202.13 },
      a4: { l: 0.67, c: 0.29, h: 242.13 },
      b0: { l: 0.94, c: 0.02, h:  82.13 },
      b1: { l: 0.92, c: 0.03, h:  82.13 },
      b2: { l: 0.90, c: 0.02, h:  82.13 },
      b3: { l: 0.90, c: 0.02, h:  82.13 },
      b4: { l: 0.89, c: 0.02, h:  82.13 },
      c0: { l: 0.25, c: 0.02, h:  82.13 },
      c1: { l: 0.36, c: 0.02, h:  82.13 },
      c2: { l: 0.47, c: 0.03, h:  82.13 },
      c3: { l: 0.58, c: 0.04, h:  82.13 },
      c4: { l: 0.69, c: 0.05, h:  82.13 },
    },
  },
  {
    id: 'Manilla',
    name: 'Manilla',
    version: 2,
    depth: 0.122,
    tokens: {
      a0: { l: 0.86, c: 0.20, h:  93 },
      a1: { l: 0.86, c: 0.20, h: 133 },
      a2: { l: 0.86, c: 0.20, h: 173 },
      a3: { l: 0.86, c: 0.20, h: 213 },
      a4: { l: 0.86, c: 0.20, h: 253 },
      b0: { l: 0.14, c: 0.00, h:  93 },
      b1: { l: 0.16, c: 0.00, h:  93 },
      b2: { l: 0.18, c: 0.00, h:  93 },
      b3: { l: 0.20, c: 0.00, h:  93 },
      b4: { l: 0.23, c: 0.00, h:  93 },
      c0: { l: 0.95, c: 0.00, h:  93 },
      c1: { l: 0.83, c: 0.00, h:  93 },
      c2: { l: 0.75, c: 0.00, h:  93 },
      c3: { l: 0.63, c: 0.00, h:  93 },
      c4: { l: 0.55, c: 0.00, h:  93 },
    },
  },
  {
    id: 'Terminal',
    name: 'Terminal',
    version: 2,
    depth: 0.1,
    tokens: {
      a0: { l: 0.67, c: 0.32, h: 166 },
      a1: { l: 0.67, c: 0.32, h: 206 },
      a2: { l: 0.67, c: 0.32, h: 246 },
      a3: { l: 0.67, c: 0.32, h: 286 },
      a4: { l: 0.67, c: 0.32, h: 326 },
      b0: { l: 0.16, c: 0.00, h: 166 },
      b1: { l: 0.20, c: 0.00, h: 166 },
      b2: { l: 0.26, c: 0.00, h: 166 },
      b3: { l: 0.29, c: 0.00, h: 166 },
      b4: { l: 0.31, c: 0.00, h: 166 },
      c0: { l: 0.95, c: 0.00, h: 166 },
      c1: { l: 0.83, c: 0.00, h: 166 },
      c2: { l: 0.75, c: 0.00, h: 166 },
      c3: { l: 0.63, c: 0.00, h: 166 },
      c4: { l: 0.55, c: 0.00, h: 166 },
    },
  },
  {
    id: 'Spirit',
    name: 'Spirit',
    version: 2,
    depth: 0.249,
    tokens: {
      a0: { l: 0.82, c: 0.28, h: 259 },
      a1: { l: 0.82, c: 0.28, h: 299 },
      a2: { l: 0.82, c: 0.28, h: 339 },
      a3: { l: 0.82, c: 0.28, h: 379 },
      a4: { l: 0.82, c: 0.28, h: 419 },
      b0: { l: 0.22, c: 0.02, h: 259 },
      b1: { l: 0.28, c: 0.02, h: 259 },
      b2: { l: 0.31, c: 0.02, h: 259 },
      b3: { l: 0.33, c: 0.02, h: 259 },
      b4: { l: 0.35, c: 0.02, h: 259 },
      c0: { l: 0.88, c: 0.02, h: 259 },
      c1: { l: 0.81, c: 0.02, h: 259 },
      c2: { l: 0.68, c: 0.02, h: 259 },
      c3: { l: 0.60, c: 0.02, h: 259 },
      c4: { l: 0.55, c: 0.02, h: 259 },
    },
  },
  {
    id: 'Lapis',
    name: 'Lapis',
    version: 2,
    depth: 0.03,
    tokens: {
      a0: { l: 0.60, c: 0.32, h: 243 },
      a1: { l: 0.60, c: 0.32, h: 283 },
      a2: { l: 0.60, c: 0.32, h: 323 },
      a3: { l: 0.60, c: 0.32, h: 363 },
      a4: { l: 0.60, c: 0.32, h: 403 },
      b0: { l: 0.97, c: 0.01, h: 243 },
      b1: { l: 0.94, c: 0.01, h: 243 },
      b2: { l: 0.93, c: 0.01, h: 243 },
      b3: { l: 0.94, c: 0.01, h: 243 },
      b4: { l: 0.92, c: 0.01, h: 243 },
      c0: { l: 0.10, c: 0.01, h: 243 },
      c1: { l: 0.35, c: 0.01, h: 243 },
      c2: { l: 0.48, c: 0.02, h: 243 },
      c3: { l: 0.58, c: 0.02, h: 243 },
      c4: { l: 0.70, c: 0.03, h: 243 },
    },
  },
  {
    id: 'Moon',
    name: 'Moon',
    version: 2,
    depth: 0.15,
    tokens: {
      a0: { l: 0.69, c: 0.17, h: 274 },
      a1: { l: 0.69, c: 0.17, h: 314 },
      a2: { l: 0.69, c: 0.17, h: 354 },
      a3: { l: 0.69, c: 0.17, h: 394 },
      a4: { l: 0.69, c: 0.17, h: 434 },
      b0: { l: 0.14, c: 0.01, h: 274 },
      b1: { l: 0.16, c: 0.01, h: 274 },
      b2: { l: 0.18, c: 0.01, h: 274 },
      b3: { l: 0.20, c: 0.01, h: 274 },
      b4: { l: 0.23, c: 0.01, h: 274 },
      c0: { l: 0.96, c: 0.01, h: 274 },
      c1: { l: 0.93, c: 0.01, h: 274 },
      c2: { l: 0.90, c: 0.01, h: 274 },
      c3: { l: 0.87, c: 0.01, h: 274 },
      c4: { l: 0.85, c: 0.01, h: 274 },
    },
  },
  {
    id: 'Rain',
    name: 'Rain',
    version: 2,
    depth: 0.137,
    tokens: {
      a0: { l: 0.59, c: 0.17, h: 318 },
      a1: { l: 0.59, c: 0.17, h: 358 },
      a2: { l: 0.59, c: 0.17, h: 398 },
      a3: { l: 0.59, c: 0.17, h: 438 },
      a4: { l: 0.59, c: 0.17, h: 478 },
      b0: { l: 0.16, c: 0.02, h: 318 },
      b1: { l: 0.20, c: 0.02, h: 318 },
      b2: { l: 0.26, c: 0.02, h: 318 },
      b3: { l: 0.28, c: 0.02, h: 318 },
      b4: { l: 0.30, c: 0.02, h: 318 },
      c0: { l: 0.84, c: 0.02, h: 318 },
      c1: { l: 0.80, c: 0.02, h: 318 },
      c2: { l: 0.76, c: 0.02, h: 318 },
      c3: { l: 0.70, c: 0.02, h: 318 },
      c4: { l: 0.65, c: 0.02, h: 318 },
    },
  },
] as const satisfies ReadonlyArray<ThemeV2>;

type DefaultTheme = (typeof DEFAULT_THEMES)[number]['id'];
